import { useBackOffice }        from '../../contexts/BackOfficeContext';

const BackOfficeFilter = () => {


    const { handleSelectedBackOffice, selectedBackOffice }  = useBackOffice();

    const style = {
        borderBottom: '2px solid #004B9B'
    }

    return (
        
        <div className="flex gap-4 overflow-auto border-b border-b-stroke font-saira">
                    
            <div 
                className="flex cursor-pointer select-none items-center gap-1 px-3 pb-3 pt-2" 
                style={selectedBackOffice === 'groups'? style : {}}
                onClick={() => handleSelectedBackOffice('groups')}
                >
                <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="currentColor" viewBox="0 0 256 256">
                    <path d="M117.25,157.92a60,60,0,1,0-66.5,0A95.83,95.83,0,0,0,3.53,195.63a8,8,0,1,0,13.4,8.74,80,80,0,0,1,134.14,0,8,8,0,0,0,13.4-8.74A95.83,95.83,0,0,0,117.25,157.92ZM40,108a44,44,0,1,1,44,44A44.05,44.05,0,0,1,40,108Zm210.14,98.7a8,8,0,0,1-11.07-2.33A79.83,79.83,0,0,0,172,168a8,8,0,0,1,0-16,44,44,0,1,0-16.34-84.87,8,8,0,1,1-5.94-14.85,60,60,0,0,1,55.53,105.64,95.83,95.83,0,0,1,47.22,37.71A8,8,0,0,1,250.14,206.7Z">
                    </path>
                </svg>
                <span>Grupos</span>
            </div>
        
            <div className="flex cursor-pointer select-none items-center gap-1 px-3 pb-3 pt-2" 
                style={selectedBackOffice === 'users'? style : {}}
                onClick={() => handleSelectedBackOffice('users')}
                >
                <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="currentColor" viewBox="0 0 256 256">
                    <path d="M230.92,212c-15.23-26.33-38.7-45.21-66.09-54.16a72,72,0,1,0-73.66,0C63.78,166.78,40.31,185.66,25.08,212a8,8,0,1,0,13.85,8c18.84-32.56,52.14-52,89.07-52s70.23,19.44,89.07,52a8,8,0,1,0,13.85-8ZM72,96a56,56,0,1,1,56,56A56.06,56.06,0,0,1,72,96Z"></path>
                </svg>
                <span>Usuários</span>
            </div>

            <div className="flex cursor-pointer select-none items-center gap-1 px-3 pb-3 pt-2"
                style={selectedBackOffice === 'pages'? style : {}}
                onClick={() => handleSelectedBackOffice('pages')}
            >
                <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="currentColor" viewBox="0 0 256 256">
                    <path d="M216,40H40A16,16,0,0,0,24,56V200a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V56A16,16,0,0,0,216,40Zm0,160H40V56H216V200ZM80,84A12,12,0,1,1,68,72,12,12,0,0,1,80,84Zm40,0a12,12,0,1,1-12-12A12,12,0,0,1,120,84Z"></path>
                </svg>
                <span>Permissões</span>
            </div>

        </div>

    )

}

export default BackOfficeFilter;